const labelPattern = /^#([\p{L}\p{N}_.-]{1,100})$/u;
export function tokens(query) {
  return [...query.matchAll(/"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\S+/gu)].map(match => ({text:match[0],start:match.index,end:match.index+match[0].length}));
}
export function parseLabels(query = '') {
  const labels=[], words=[];
  for (const token of tokens(query)) {
    const match=token.text.match(labelPattern);
    if (match) { const slug=match[1].toLowerCase(); if (!labels.includes(slug)) labels.push(slug); }
    else words.push(token.text);
  }
  return {labels,q:words.join(' ')};
}
export function activeLabel(query, cursor=query.length) {
  const token=tokens(query).find(token=>token.start<cursor && cursor<=token.end);
  if (!token || !/^#[\p{L}\p{N}_.-]*$/u.test(token.text)) return null;
  return {...token,term:query.slice(token.start+1,cursor)};
}
export function removeLabel(query, slug) {
  return tokens(query).filter(token=>token.text.toLowerCase()!==`#${slug.toLowerCase()}`).map(token=>token.text).join(' ');
}
export function replaceLabel(query, token, slug) {
  return query.slice(0,token.start)+'#'+slug+' '+query.slice(token.end).trimStart();
}

flarum.reg.add('nightash-labels', 'common/utils/labelQuery', { tokens: tokens,parseLabels: parseLabels,activeLabel: activeLabel,removeLabel: removeLabel,replaceLabel: replaceLabel, });